class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);

    // Focus inside the tap so the mobile keyboard opens straight away
    const input = this.detailsContainer.querySelector('input:not([type="hidden"])');
    if (input) input.focus({ preventScroll: true });

    // Scroll lock, focus trap and outside-click listener run after the paint
    requestAnimationFrame(() => {
      setTimeout(() => {
        if (!this.isOpen()) return;
        document.body.addEventListener('click', this.onBodyClickEvent);
        document.documentElement.style.overflow = 'hidden';   /* lock the page on <html>, not <body>, so the sticky header stays in place */
        trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), input || this.summaryToggle);
      }, 0);
    });
  }

  close(focusToggle = true) {
    this.detailsContainer.removeAttribute('open');

    requestAnimationFrame(() => {
      setTimeout(() => {
        if (this.isOpen()) return;
        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.documentElement.style.overflow = '';
        removeTrapFocus(focusToggle ? this.summaryToggle : null);
      }, 0);
    });
  }
}

customElements.define('details-modal', DetailsModal);